import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import './progressbar.css';
import { Disposable } from '../../../common/lifecycle.js';
import { Color } from '../../../common/color.js';
import { mixin } from '../../../common/objects.js';
import { removeClasses, addClass, hasClass, addClasses, show } from '../../dom.js';
import { RunOnceScheduler } from '../../../common/async.js';
var css_done = 'done';
var css_active = 'active';
var css_infinite = 'infinite';
var css_discrete = 'discrete';
var css_progress_container = 'monaco-progress-container';
var css_progress_bit = 'progress-bit';
var defaultOpts = {
  progressBarBackground: Color.fromHex('#0E70C0')
};
/**
 * A progress bar with support for infinite or discrete progress.
 */

export var ProgressBar = /*#__PURE__*/function (_Disposable) {
  _inherits(ProgressBar, _Disposable);

  var _super = _createSuper(ProgressBar);

  function ProgressBar(container, options) {
    var _this;

    _classCallCheck(this, ProgressBar);

    _this = _super.call(this);
    _this.options = options || Object.create(null);
    mixin(_this.options, defaultOpts, false);
    _this.workedVal = 0;
    _this.progressBarBackground = _this.options.progressBarBackground;

    _this._register(_this.showDelayedScheduler = new RunOnceScheduler(function () {
      return show(_this.element);
    }, 0));

    _this.create(container);

    return _this;
  }

  _createClass(ProgressBar, [{
    key: "create",
    value: function create(container) {
      this.element = document.createElement('div');
      addClass(this.element, css_progress_container);
      container.appendChild(this.element);
      this.bit = document.createElement('div');
      addClass(this.bit, css_progress_bit);
      this.element.appendChild(this.bit);
      this.applyStyles();
    }
  }, {
    key: "off",
    value: function off() {
      this.bit.style.width = 'inherit';
      this.bit.style.opacity = '1';
      removeClasses(this.element, css_active, css_infinite, css_discrete);
      this.workedVal = 0;
      this.totalWork = undefined;
    }
    /**
     * Stops the progressbar from showing any progress instantly without fading out.
     */

  }, {
    key: "stop",
    value: function stop() {
      return this.doDone(false);
    }
  }, {
    key: "doDone",
    value: function doDone(delayed) {
      var _this2 = this;

      addClass(this.element, css_done); // let it grow to 100% width and hide afterwards

      if (!hasClass(this.element, css_infinite)) {
        this.bit.style.width = 'inherit';

        if (delayed) {
          setTimeout(function () {
            return _this2.off();
          }, 200);
        } else {
          this.off();
        }
      } // let it fade out and hide afterwards
      else {
        this.bit.style.opacity = '0';

        if (delayed) {
          setTimeout(function () {
            return _this2.off();
          }, 200);
        } else {
          this.off();
        }
      }

      return this;
    }
    /**
     * Use this mode to indicate progress that has no total number of work units.
     */

  }, {
    key: "infinite",
    value: function infinite() {
      this.bit.style.width = '2%';
      this.bit.style.opacity = '1';
      removeClasses(this.element, css_discrete, css_done);
      addClasses(this.element, css_active, css_infinite);
      return this;
    }
  }, {
    key: "getContainer",
    value: function getContainer() {
      return this.element;
    }
  }, {
    key: "style",
    value: function style(styles) {
      this.progressBarBackground = styles.progressBarBackground;
      this.applyStyles();
    }
  }, {
    key: "applyStyles",
    value: function applyStyles() {
      if (this.bit) {
        var background = this.progressBarBackground ? this.progressBarBackground.toString() : '';
        this.bit.style.backgroundColor = background;
      }
    }
  }]);

  return ProgressBar;
}(Disposable);